import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const COMPLETE_STEP_MUTATION = mutation({
  completeStep: [
    { input: input('input', 'CompleteStepInput!') },
    {
      completedAt: true,
    },
  ],
});

type CompleteStepInputType = VariablesOf<typeof COMPLETE_STEP_MUTATION>['input'];
type CompleteStepResponseType = ResultOf<typeof COMPLETE_STEP_MUTATION>['completeStep'];

export const completeStepMutationRequest = async (
  props: CompleteStepInputType
): Promise<ResultType<CompleteStepResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(COMPLETE_STEP_MUTATION, { input: props }, { useAuth: true });

  return {
    success: Boolean(response?.completeStep?.completedAt),
    data: response?.completeStep ?? { completedAt: false },
  };
};
